import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { IStudy } from '@vivli/features/studies/infrastructure/interface';
import { useEffect, useRef, useState } from 'react';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

export function useExternalLinkPermissionsHook(study: IStudy) {
    const [canEditLinks, setCanEditLinks] = useState(false);
    const [isLoadingPermissions, setIsLoadingPermissions] = useState(true);
    const permissionsLoadedRef = useRef(false);
    const { user, orgHasPermission, hasPermission } = useActiveUserContext();

    useEffect(() => {
        if (!study) {
            return;
        }
        //TODO PERMFE - redo with permissions+
        const userHasOrgAdminOrProvider = orgHasPermission(study.orgId, PermissionsEnum.ContribChat);
        const _canEditLinks = hasPermission(PermissionsEnum.EditStudyAdv) || userHasOrgAdminOrProvider;
        setCanEditLinks(_canEditLinks);
    }, [study]);

    useEffect(() => {
        if (!permissionsLoadedRef.current) {
            permissionsLoadedRef.current = true;
            setIsLoadingPermissions(false);
        }
    }, [canEditLinks]);

    return {
        canEditLinks,
        isLoadingPermissions,
    };
}
